import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MuiTabNavItemBase } from '../../core/mui-tab-nav-item-base';

let tabId = 0;

@Component({
  selector: 'mui-tab',
  templateUrl: './mui-tab.component.html'
})
export class MuiTab extends MuiTabNavItemBase {
  @ViewChild('ref', { static: true, read: TemplateRef })
  template!: TemplateRef<any>;

  readonly uid: string;

  constructor() {
    super();
    this.uid = 'mui-tab-' + tabId++;
  }
}
